module.exports = __webpack_public_path__ + "static/media/YF33_0.7eb0b0db.jpg";